<template>
  <div class="my-tabs item5">
    <ul class="nav">
      <li
        v-for="item in tabs"
        :key="item.id"
        :class="typeTab === item.id ? 'active' : ''"
        @click="typeTab = item.id"
      >{{ item.name }}</li>
    </ul>
    <ul class="content">
      <template v-for="item in tabs">
        <li :key="item.id" v-show="typeTab === item.id">
          <el-alert title="完整度匹配，填写的所有占比值加起来不能超过100%，并且必须等于100%，占比值为整数" type="warning" closable></el-alert>
          <el-collapse :value="item.list.map(i => i.id)">
            <el-collapse-item
                v-for="group in item.list"
                :title="group.name"
                :name="group.id"
                :key="group.id"
            >
              <ul class="input-list">
                <li v-for="num in group.list" :key="num.id">
                  <span class="lable">{{ num.name }}</span>
                  <el-input-number size="mini" v-model="num.proportion" :precision="0" controls-position="right"></el-input-number>
                  <span>%</span>
                </li>
              </ul>
            </el-collapse-item>
          </el-collapse>
          <div class="tool">
            <el-button type="primary" @click="saveConfig(item)">保存</el-button>
          </div>
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
export default {
  name: "Item5",
  props: {
    tabs: {
      type: Array,
      default: () => []
    },
    humble: {
      type: Boolean
    }
  },
  data() {
    return {
      typeTab: '1'
    }
  },
  watch: {
    tabs(newVal) {
      if (!newVal) {
        return
      }
      const item = newVal[0] || {}
      this.typeTab = item.id
    }
  },
  created() {

  },
  methods: {
    saveConfig(config) {
      this.$emit('saveConfig', this.makePermas(config))
    },
    makePermas(config) {
      const obj = []
      const humble = this.humble
      function deep(list) {
        if (list.length === 0) {
          return
        }
        const first = list[0] || {}
        if (!first.list || first.list.length === 0) {
          if (humble) {
            // obj.push(...list.map(i => ({pcode: i.pcode, proportion: i.proportion })))
            obj.push(...list.map(i => ({code: i.code, proportion: i.proportion })))
          } else {
            obj.push(...list)
          }
          return
        }
        for (let index in list) {
          const item = list[index]
          deep(item.list)
        }
      }
      deep(config.list)
      return {
        pcode: config.pcode,
        list: obj
      }
    }
  }
}
</script>

<style scoped lang="less">
.my-tabs {
  font-size: 14px;
  .nav {
    background: #EFF2FF;
    display: flex;
    position:relative;
    margin: 0;
    li {
      cursor:pointer;
      height: 35px;
      line-height: 35px;
      padding: 0 30px;
    }
  }
  .content {
    padding: 20px;
  }
}


.input-list {
  display: flex;
  flex-wrap: wrap;
  li {
    width: 180px;
    margin: 0 40px 20px 0;
    .lable {
      display: inline-block;
      width: 70px;
      text-align: right;
      padding-right: 1em;
      box-sizing: border-box;
    }
    .el-input-number {
      width: 90px;
    }
  }
}
.tool {
  text-align: center;
  margin: 40px 0;
}
</style>